"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changedField = changedField;
exports.updatedField = updatedField;
exports.presentChanges = presentChanges;
exports.formatShiftDate = formatShiftDate;
exports.shiftTimeOfDayLabel = shiftTimeOfDayLabel;
exports.formatShiftTimeRange = formatShiftTimeRange;
exports.formatHourlyRate = formatHourlyRate;
exports.formatTravelStipend = formatTravelStipend;
exports.travelStipendChange = travelStipendChange;
const formatters_1 = require("./formatters");
const TIME_OF_DAY_LABELS = {
    DAYS: 'Days',
    EVES: 'Evenings',
    NIGHTS: 'Nights',
};
function changedField(label, previous, current) {
    return previous === current
        ? undefined
        : { kind: 'changed', label, previous, current };
}
function updatedField(label, previous, current) {
    return previous === current ? undefined : { kind: 'updated', label };
}
function presentChanges(changes) {
    return changes.filter((change) => !!change);
}
function formatShiftDate(date) {
    return date.toFormat('LLL d, yyyy');
}
function shiftTimeOfDayLabel(shiftTime) {
    return TIME_OF_DAY_LABELS[shiftTime.split('_')[0]];
}
function formatShiftTimeRange(timeOfDay, from, to) {
    const range = `${from}–${to}`;
    return timeOfDay ? `${timeOfDay} ${range}` : range;
}
function formatHourlyRate(cents) {
    return `${(0, formatters_1.toDollarAmount)(cents, false)}/hr`;
}
function formatTravelStipend(totalCents, minimumDistance) {
    const perShift = `${(0, formatters_1.toDollarAmount)(totalCents)}/shift`;
    return minimumDistance
        ? `${perShift} (${minimumDistance} mi minimum)`
        : perShift;
}
function travelStipendChange(before, after) {
    const label = 'Travel stipend';
    const had = before.totalCents > 0;
    const has = after.totalCents > 0;
    if (!had && !has) {
        return undefined;
    }
    if (!had) {
        return {
            kind: 'added',
            label,
            current: formatTravelStipend(after.totalCents, after.minimumDistance),
        };
    }
    if (!has) {
        return { kind: 'removed', label };
    }
    return changedField(label, formatTravelStipend(before.totalCents, before.minimumDistance), formatTravelStipend(after.totalCents, after.minimumDistance));
}
//# sourceMappingURL=field-changes.js.map